import { LangEn } from 'assets/locales/en';
import { Language } from 'assets/locales/fLang';
import { LangFr } from 'assets/locales/fr';

// Validation and summaries are plain functions, called outside the React tree
// that holds the language manager: they read the same locale files, in the
// language Context.js sets for the whole admin.
const language = new Language();
language.loadLanguage(LangFr);
language.loadLanguage(LangEn);
language.setLanguage('fr');

/** A `missionTemplate.*` text, with its `{name}` placeholders filled in. */
export const templateText = (key, values = {}) =>
  Object.keys(values).reduce(
    (text, name) => text.split(`{${name}}`).join(String(values[name])),
    language.getValue(`missionTemplate.${key}`, '')
  );
